// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__38tSO","right":"Footer_right__1tVsY","buttons":"Footer_buttons__1xQTC"};